'use client';

import { ListOptionGroup, listOptionGroupTag } from '@ni/nimble-components/dist/esm/list-option-group';
import { wrap } from '../utilities/react-wrapper';

export { listOptionGroupTag };
export { type ListOptionGroup };
export const NimbleListOptionGroup = wrap(ListOptionGroup);
